import $ from "jquery";

import * as deviceDetect from "deviceDetect";
import readlangClient from "readlangClient";

const variations = window.READLANG.splitTests || {};

export const getAllVariations = () => variations;

export const trackEvent = (eventName, cb?: () => void) => {
  trackEventWithProperties(eventName, {}, cb);
};

export const trackEventWithProperties = (
  eventName,
  properties,
  cb?: (data: any) => void
) => {
  properties = {
    windowWidth: $(window).width(),
    windowHeight: $(window).height(),
    isStandalone: deviceDetect.isStandalone(),
    ...properties,
  };

  readlangClient.request(
    "POST",
    "/api/splitTests/trackEvent/" + eventName,
    { properties },
    (data) => {
      if (data.error) {
        alert(data.error);
      } else if (cb) {
        cb(data);
      }
    }
  );
};
